<template>
  <div class="content-8__content">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>{{ isHK ? '日期/期数':'时间/期数' }}</th>
            <th>特码</th>
            <th>大小</th>
            <th>单双</th>
            <th>合大小</th>
            <th>合单双</th>
            <th>尾大小</th>
            <th>半特</th>
            <th>生肖</th>
            <th>尾数</th>
            <th>色波</th>
            <th>半波</th>
            <th>半半波</th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(period, periodIndex) in tableData">
            <tr v-if="periodIndex < extendConut" :key="`${periodIndex}-tableData`">
              <!-- 期数 -->
              <td>
                <div class="tableballbox">
                  <span v-if="isHK" class="textbox__text">
                    {{ formatDrawTime(period.drawTime) }} {{ period.period.substr(4) }}期
                  </span>
                  <span v-else class="textbox__text">
                    {{ formatDrawTime(period.drawTime) }} {{ period.period }}期
                  </span>
                </div>
              </td>
              <!-- 特码 -->
              <td>
                <div class="tableballbox">
                  <div class="tableballbox__item">
                    <div
                      class="ball circle size-middle"
                      :class="getSebo(periodIndex,6)"
                    >
                      <span class="ball__number">{{ padZero(period.balls[6]) }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- 大小 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" :class=" textColor(period.hmDaXiao[6])">{{ ruleCodeMapping[period.hmDaXiao[6]] }}</span>
                </div>
              </td>
              <!-- 单双 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" :class=" textColor(period.hmDanShuang[6])">{{ ruleCodeMapping[period.hmDanShuang[6]] }}</span>
                </div>
              </td>
              <!-- 合大小 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" :class=" textColor(period.hmHeDaXiao[6])">{{ ruleCodeMapping[period.hmHeDaXiao[6]] }}</span>
                </div>
              </td>
              <!-- 合单双 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" :class=" textColor(period.hmHeDanShuang[6])">{{ ruleCodeMapping[period.hmHeDanShuang[6]] }}</span>
                </div>
              </td>
              <!-- 尾大小 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" :class=" textColor(period.hmWeiShuDaXiao[6])">
                    尾{{ ruleCodeMapping[period.hmWeiShuDaXiao[6]] }}
                  </span>
                </div>
              </td>
              <!-- 半特 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.hmDaXiao[6]] }}{{ ruleCodeMapping[period.hmDanShuang[6]] }}</span>
                </div>
              </td>
              <!-- 生肖 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.shengXiao[6]] }} {{ ruleCodeMapping[period.shengXiaoDongWu[6]] }}</span>
                </div>
              </td>
              <!-- 尾数 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ getUnits(period.balls[6]) }}</span>
                </div>
              </td>
              <!-- 色波 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.seBo[6]] }}</span>
                </div>
              </td>
              <!-- 半波 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.seBo[6]] }}{{ ruleCodeMapping[period.hmDaXiao[6]] }}</span>
                  <span> </span>
                  <span class="textbox__text">{{ ruleCodeMapping[period.seBo[6]] }}{{ ruleCodeMapping[period.hmDanShuang[6]] }}</span>
                </div>
              </td>
              <!-- 半半波 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.seBo[6]] }}{{ ruleCodeMapping[period.hmDaXiao[6]] }}{{ ruleCodeMapping[period.hmDanShuang[6]] }}</span>
                </div>
              </td>

            </tr>
          </template>
          <tr v-if="!noMore">
            <td colspan="15">
              <span class="button-primary c8-datebox__item active" @click="loadList">显示更多</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import moment from 'moment'

export default {
  name: 'TeMaFenXi',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      extendConut: 30,
      selectFilterProperty: '',
      ruleCodeMapping: ruleCodeMapping
    }
  },
  computed: {
    noMore() {
      return this.extendConut >= this.tableData.length
    },
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    }
  },
  methods: {
    // 轉換utc時間格式
    formatDrawTime(time) {
      return this.isHK ? moment(time).format('YYYY/MM/DD') : moment(time).format('HH:mm')
    },
    // 拿顏色
    getSebo(periodIndex, ballIndex) {
      switch (this.tableData[periodIndex].seBo[ballIndex]) {
        case 'yanse_hong':
          return 'color--red'
        case 'yanse_lan':
          return 'color--blue'
        case 'yanse_lyu':
          return 'color--green'
        default:
          return ''
      }
    },
    // 取個位數
    getUnits(number) {
      return parseInt(number % 10)
    },
    textColor(value) {
      switch (value) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
          return 'red'
        case 'yanse_lan':
        case 'daxiao_he':
        case 'danshuang_he':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    // 一次性載入的數量
    loadList() {
      this.extendConut += 30
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
  .c8-datebox__item {
    &:hover {
      cursor: pointer;
    }
  }
</style>
